/**
 * La url pertenece a un video?
 * @param {String} url
 * @returns {Boolean}
 */
export const isVideo = (url) => /\.(mp4|avi|mov)$/i.test(url);
/**
 * La url pertenece a una imagen?
 * @param {String} url
 * @returns {Boolean}
 */
export const isImage = (url) => /\.(jpg|jpeg|png|gif)$/i.test(url);
/**
 * El navegador puede mostrar el documento? Word y Excel no: al abrirlos se
 * descargan, así que para ellos no se ofrece "Vista previa".
 * @param {String} url
 * @returns {Boolean}
 */
export const canPreview = (url) => !/\.(docx?|xlsx?)$/i.test(url);

/**
 * La url pertenece a un video de youtube?
 * @param {String} url
 * @returns {Boolean}
 */
export const isYoutube = (url) => /youtube\.com|youtu\.be/.test(url);

/**
 * La url pertenece a un reporte de Power BI?
 * @param {String} url
 * @returns {Boolean}
 */
export const isPowerBi = (url) => /powerbi\.com/.test(url);

/**
 * La url pertenece a un video de Vimeo?
 * @param {String} url
 * @returns {Boolean}
 */
export const isVimeo = (url) => /vimeo\.com/.test(url);


const formatArrText = new Intl.ListFormat("es", {
  style: "long",
  type: "conjunction",
});

export function formatArrayText(arr) {
  if (!arr || !Array.isArray(arr) || arr.length === 0) {
    return "";
  }
  return formatArrText.format(arr);
}

export function formatEspNumber(value, options = {}) {
  const number = Number(value);
  try {
    return number.toLocaleString("es-ES", {
      useGrouping: true,
      minimumFractionDigits: options.minimumFractionDigits || 0,
      maximumFractionDigits: options.maximumFractionDigits || 0,
    });
  } catch (e) {
    console.error(e);
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}

export const formatEspDateTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Escapa un texto para meterlo en HTML, por ejemplo en el msg de Question,
 * que se pinta con v-html: un nombre con "<" no se interpreta como etiqueta.
 * @param {*} texto
 * @returns {String}
 */
export const escaparHtml = (texto) =>
  String(texto ?? "").replace(
    /[&<>"']/g,
    (caracter) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[caracter],
  );